import React from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import { error } from '@react/react-spectrum/Toast'

import Checkbox from '@react/react-spectrum/Checkbox'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Tooltip from '@react/react-spectrum/Tooltip'
import Select from '@react/react-spectrum/Select'
import FieldLabel from '@react/react-spectrum/FieldLabel'

export default function Params (props) {
    function setOption (field, selected) {
        const options = {}
        options[field] = props.params[field].map(option => {
            option.selected = false
            if (option.value === selected) {
                option.selected = true
            }
            return option
        })

        props.setParams({ ...props.params, ...options })
    }

    function setCheckboxOption (field, checked) {
        const options = {}
        options[field] = checked
        props.setParams({ ...props.params, ...options })
    }

    try {
        return <div className="adobe-skycity-output-options">
            <Well>
                <Heading variant="pageTitle">{__('skycity_comp_title_output_options')}</Heading>
                <React.Fragment>
                    <Heading className="adobe-skycity-subtitle1" variant="subtitle1">Params</Heading>
                    <Well>
                        <div className="adobe-skycity-options-col">
                            <div className="adobe-skycity-option">
                                <FieldLabel className="adobe-skycity-options-field" label="Service Mode" labelFor="idServiceMode" position="left">
                                    <OverlayTrigger placement="right">
                                        <Select
                                            options={props.params.serviceMode}
                                            onChange={e => setOption('serviceMode', e)}
                                            id="idServiceMode" />
                                        <Tooltip variant="info">
                                            {__('output_option_tooltip_servicemode_imagecutoutv4sensei')}
                                        </Tooltip>
                                    </OverlayTrigger>
                                </FieldLabel>
                            </div>
                            <div className="adobe-skycity-option">
                                <FieldLabel className="adobe-skycity-options-field" label="Mask Format" labelFor="idMaskFormat" position="left">
                                    <OverlayTrigger placement="right">
                                        <Select
                                            options={props.params.maskFormat}
                                            onChange={e => setOption('maskFormat', e)}
                                            id="idMaskFormat" />
                                        <Tooltip variant="info">
                                            {__('output_option_tooltip_maskformat_imagecutoutv4sensei')}
                                        </Tooltip>
                                    </OverlayTrigger>
                                </FieldLabel>
                            </div>
                            <div className="adobe-skycity-option">
                                <Checkbox
                                    id="idTrim"
                                    checked={props.params.trim}
                                    onChange={e => setCheckboxOption('trim', e)}
                                >
                                    Trim
                                </Checkbox>
                            </div>
                            <div className="adobe-skycity-option">
                                <Checkbox
                                    id="idSoftMask"
                                    checked={props.params.softMask}
                                    onChange={e => setCheckboxOption('softMask', e)}
                                >
                                    Soft Mask
                                </Checkbox>
                            </div>
                            <div className="adobe-skycity-option">
                                <FieldLabel className="adobe-skycity-options-field" label="Background Color" labelFor="idBackgroundColor" position="left">
                                    <input
                                        type="text"
                                        id="idBackgroundColor"
                                        value={props.params.backgroundColor}
                                        onChange={e => setCheckboxOption('backgroundColor', e.target.value)}
                                    />
                                </FieldLabel>
                            </div>
                            <div className="adobe-skycity-option">
                                <Checkbox
                                    id="idColorDecontamination"
                                    checked={props.params.colorDecontamination}
                                    onChange={e => setCheckboxOption('colorDecontamination', e)}
                                >
                                    Color Decontamination
                                </Checkbox>
                            </div>
                            <div className="adobe-skycity-option">
                                <Checkbox
                                    id="idMultipleMasks"
                                    checked={props.params.multipleMasks}
                                    onChange={e => setCheckboxOption('multipleMasks', e)}
                                >
                                    Multiple Masks
                                </Checkbox>
                            </div>
                            <div className="adobe-skycity-option">
                                <Checkbox
                                    id="idIncludeBbox"
                                    checked={props.params.includeBbox}
                                    onChange={e => setCheckboxOption('includeBbox', e)}
                                >
                                    Include Bounding Box
                                </Checkbox>
                            </div>
                        </div>
                    </Well>
                </React.Fragment>
            </Well>
        </div>
    } catch (e) {
        console.log(e)
        error(`${__('error_msg_title')}: ${e}`, {
            timeout: 0
        })
    }
}
